"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = buildMemoryTimeline;
const helpers_1 = require("../shared/helpers");
// setup
const taskSetup_1 = require("../taskSetup");
const taskSetup_2 = require("../taskSetup");
// trials
const trials_1 = require("../shared/trials");
const stimulus_1 = require("./trials/stimulus");
const instructions_1 = require("./trials/instructions");
const taskStore_1 = require("../../taskStore");
const __1 = require("../..");
const generatePracticeTrialTimeline = (reverse, tryAgainText, repetitions) => {
    const basicBlock = [
        (0, stimulus_1.getCorsiBlocks)({ mode: 'display', isPractice: true, reverse }),
        (0, stimulus_1.getCorsiBlocks)({ mode: 'input', isPractice: true, reverse }),
        (0, trials_1.feedback)(true, 'feedbackCorrect', tryAgainText, true),
    ];
    const finalTimeline = [];
    for (let i = 0; i < repetitions; i += 1) {
        finalTimeline.push(...basicBlock);
    }
    return finalTimeline;
};
const getSecondRoundPracticeTrials = (reverse, tryAgainText) => {
    return {
        timeline: [
            ...generatePracticeTrialTimeline(reverse, tryAgainText, 2),
            (0, stimulus_1.getCorsiBlocks)({ mode: 'display', isPractice: true, reverse }),
            (0, stimulus_1.getCorsiBlocks)({ mode: 'input', isPractice: true, reverse }),
            {
                timeline: [(0, trials_1.feedback)(true, 'feedbackCorrect', tryAgainText, true)],
                conditional_function: () => {
                    return (0, taskStore_1.taskStore)().isCorrect;
                },
            },
        ],
        conditional_function: () => {
            return !(0, taskStore_1.taskStore)().isCorrect;
        },
    };
};
function buildMemoryTimeline(config) {
    const { heavyInstructions } = (0, taskStore_1.taskStore)();
    (0, helpers_1.initTrialSaving)(config);
    const preloadTrials = (0, helpers_1.createPreloadTrials)(__1.mediaAssets).default;
    const initialTimeline = (0, helpers_1.initTimeline)(config, trials_1.enterFullscreen);
    const corsiBlocksPractice = {
        timeline: [...generatePracticeTrialTimeline(false, 'memoryGameForwardTryAgain', 3)],
    };
    const corsiBlocksPracticeReverse = {
        timeline: [...generatePracticeTrialTimeline(true, 'memoryGameBackwardTryAgain', 3)],
    };
    const forwardTrial = () => {
        return {
            timeline: [(0, stimulus_1.getCorsiBlocks)({ mode: 'display' }), (0, stimulus_1.getCorsiBlocks)({ mode: 'input' })],
            conditional_function: () => {
                return (0, taskStore_1.taskStore)().numIncorrect < (0, taskStore_1.taskStore)().maxIncorrect;
            },
        };
    };
    const corsiBlocksStimulus = {
        timeline: [forwardTrial()],
        repetitions: 16,
    };
    // last forward trial by itself in order to reset sequence length back to 2 for backward phase
    const forwardTrialResetSeq = {
        timeline: [(0, stimulus_1.getCorsiBlocks)({ mode: 'display' }), (0, stimulus_1.getCorsiBlocks)({ mode: 'input', resetSeq: true })],
        conditional_function: () => {
            const result = (0, taskStore_1.taskStore)().numIncorrect < (0, taskStore_1.taskStore)().maxIncorrect;
            (0, taskStore_1.taskStore)('numIncorrect', 0); // reset to 0 here so that reverse block isn't skipped
            return result;
        },
    };
    const corsiBlocksReverse = {
        timeline: [(0, stimulus_1.getCorsiBlocks)({ mode: 'display', reverse: true }), (0, stimulus_1.getCorsiBlocks)({ mode: 'input', reverse: true })],
        repetitions: 21,
    };
    const totalRealTrials = corsiBlocksStimulus.repetitions + corsiBlocksReverse.repetitions;
    (0, taskStore_1.taskStore)('totalTestTrials', totalRealTrials);
    const downexFeedbackCorrect = {
        timeline: [(0, trials_1.feedback)(true, 'feedbackCorrect', 'memoryGameForwardTryAgain', true)],
        conditional_function: () => {
            return (0, taskStore_1.taskStore)().isCorrect;
        },
    };
    const downexFeedbackIncorrect = (reverse, prompt) => {
        return {
            timeline: [(0, stimulus_1.getCorsiBlocks)({ reverse, mode: 'input', isPractice: true, animation: 'pulse', prompt })],
            conditional_function: () => {
                return !(0, taskStore_1.taskStore)().isCorrect;
            },
        };
    };
    const downexPracticeTrial = (reverse, seqlength, animation) => {
        return {
            timeline: [
                (0, stimulus_1.getCorsiBlocks)({ reverse, mode: 'display', isPractice: true, customSeqLength: seqlength }),
                (0, stimulus_1.getCorsiBlocks)({ reverse, mode: 'input', isPractice: true, animation }),
                downexFeedbackCorrect,
                downexFeedbackIncorrect(reverse, reverse ? 'memoryGameInstruct11Downex' : 'memoryGameFeedbackIncorrectDownex'),
            ],
        };
    };
    const downexInstructionsTimeline = {
        timeline: [
            instructions_1.downexInstructions[0],
            downexPracticeTrial(false, 1, 'cursor'),
            downexPracticeTrial(false, 1),
            instructions_1.downexInstructions[1],
            downexPracticeTrial(false, 2, 'cursor'),
            downexPracticeTrial(false, 2),
            downexPracticeTrial(false, 2),
            instructions_1.downexInstructions[2],
            instructions_1.downexInstructions[3],
            instructions_1.downexInstructions[4],
        ],
    };
    let fellBack = false;
    const fallbackBlock = {
        timeline: [trials_1.repeatInstructionsMessage, ...downexInstructionsTimeline.timeline.slice(1)],
        conditional_function: () => {
            const run = (0, helpers_1.checkFallbackCriteria)(true) && !fellBack;
            if (run) {
                fellBack = true;
                (0, taskStore_1.taskStore)('heavyInstructions', true);
                (0, taskStore_1.taskStore)('gridSize', 2);
                (0, taskStore_1.taskStore)('numOfBlocks', 4);
                (0, taskStore_1.taskStore)('blockSize', 50);
            }
            return run;
        },
    };
    const firstFourTestTrials = {
        timeline: [forwardTrial(), fallbackBlock],
        repetitions: 4,
    };
    const downexCorsiBlocksPracticeReverse = {
        timeline: [downexPracticeTrial(true, 2, 'cursor'), downexPracticeTrial(true, 2), downexPracticeTrial(true, 2)],
    };
    const defaultCorsiBlocksPracticeReverse = {
        timeline: [
            instructions_1.reverseOrderPrompt,
            corsiBlocksPracticeReverse,
            getSecondRoundPracticeTrials(true, 'memoryGameBackwardTryAgain'),
        ],
    };
    const defaultInstructionsTimeline = {
        timeline: [
            ...instructions_1.defaultInstructions,
            corsiBlocksPractice,
            getSecondRoundPracticeTrials(false, 'memoryGameForwardTryAgain'),
            instructions_1.readyToPlay,
        ],
    };
    const timeline = [
        preloadTrials,
        initialTimeline,
        heavyInstructions ? downexInstructionsTimeline : defaultInstructionsTimeline,
        trials_1.ifNotFullscreen,
        firstFourTestTrials, // check for fallback criteria during first 4 trials
        trials_1.ifNotFullscreen,
        corsiBlocksStimulus,
        forwardTrialResetSeq,
        instructions_1.reverseOrderInstructions,
        trials_1.ifNotFullscreen,
        heavyInstructions ? downexCorsiBlocksPracticeReverse : defaultCorsiBlocksPracticeReverse,
        instructions_1.readyToPlay,
        trials_1.ifNotFullscreen,
        corsiBlocksReverse,
        (0, trials_1.taskFinished)(),
    ];
    /**
     * Old timeline
     * const timeline: any[] = [
        preloadTrials,
        initialTimeline,
        ...instructions,
        ifNotFullscreen,
        corsiBlocksPractice,
        getSecondRoundPracticeTrials(false, 'memoryGameForwardTryAgain'),
        readyToPlay,
        ifNotFullscreen,
        corsiBlocksStimulus,
        forwardTrialResetSeq,
        reverseOrderInstructions,
        reverseOrderPrompt,
        ifNotFullscreen,
        corsiBlocksPracticeReverse,
        getSecondRoundPracticeTrials(true, 'memoryGameBackwardTryAgain'),
        readyToPlay,
        ifNotFullscreen,
        corsiBlocksReverse,
        taskFinished(),
      ];
     */
    (0, taskSetup_2.initializeCat)();
    timeline.push(trials_1.exitFullscreen);
    return { jsPsych: taskSetup_1.jsPsych, timeline };
}
